import React from "react";

export default function PrintHeader() {
  return (
    <div
      style={{
        width: "100%",
        padding: "12px 10px",
        borderBottom: "3px solid #99b3e6",
        textAlign: "center",
        fontFamily: "Arial, sans-serif",
        color: "#003380",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",         // allow wrapping on small screens
          alignItems: "center",
          justifyContent: "center",
          gap: "15px",
          maxWidth: "900px",
          margin: "0 auto",
        }}
      >
        <img
          src="/favicon.ico"
          alt="Left Logo"
          style={{
            width: "8vw",            // responsive width (8% of viewport width)
            maxWidth: "60px",        // max size limit
            height: "auto",
            verticalAlign: "middle",
          }}
        />
        <span
          style={{
            flex: "1 1 300px",       // flexible width, min 300px
            fontWeight: "bold",
            fontSize: "1.2rem",      // responsive font size
            lineHeight: "1.2",
            color: "#003380",
            textAlign: "center",
            minWidth: 0,             // prevent flex overflow
          }}
        >
          ALL INDIA INSTITUTE OF MEDICAL SCIENCES NAGPUR
        </span>
        <img
          src="/icmr_logo_verti.png"
          alt="Right Logo"
          style={{
            width: "10vw",           // responsive width
            maxWidth: "80px",
            height: "auto",
            verticalAlign: "middle",
          }}
        />
      </div>

      <p
        style={{
          marginTop: 8,
          fontWeight: 600,
          fontSize: "1rem",
          maxWidth: "900px",
          marginLeft: "auto",
          marginRight: "auto",
          lineHeight: "1.3",
        }}
      >
        Validating PIWIL mRNA and protein signatures as predictive markers for fertilizing competence of sperm - A multicentric cohort study
      </p>
      <p
        style={{
          fontWeight: "bold",
          fontSize: "1rem",
          maxWidth: "900px",
          marginLeft: "auto",
          marginRight: "auto",
          lineHeight: "1.3",
        }}
      >
        Project ID: IIRPIG-2024-01-01230 (ICMR) <br></br> PI: Dr. T.S. Gugapriya<br></br>
              Co-PIs: Dr. Anjoo Agarwal, Dr. Bindu Bajaj, Dr. Navdeep Kaur Ghuman
      </p>
    </div>
  );
}
